import { render, staticRenderFns } from "./groupedproductCard.vue?vue&type=template&id=df4a6474&scoped=true&"
import script from "./groupedproductCard.vue?vue&type=script&lang=js&"
export * from "./groupedproductCard.vue?vue&type=script&lang=js&"
import style0 from "./groupedproductCard.vue?vue&type=style&index=0&id=df4a6474&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4a6474",
  null
  
)

export default component.exports